<template>
  <VisionIconButton
    icon="chevron"
    :size="size"
    :class="bem('button', {
      'is-visible': isVisible,
      'is-disabled': isDisabled,
      'rotated': arrow === 'left'
    })"
    :icon-colour="calculatedIconColour"
    :background-colour="props.backgroundColour"
    :data-carousel-arrow="arrow"
 />
</template>

<script setup>
const bem = useBEM('CarouselArrow')

const props = defineProps({
  arrow: { type: String, default: 'right' },
  isVisible: { type: Boolean, default: true },
  isDisabled: { type: Boolean, default: false },
  backgroundColour: {
    type: String,
    default: 'white',
    validator(value) {
      return ['white', 'dark-grey'].includes(value)
    }
  },
  size: {
    type: String,
    default: 'x-small',
    validator(value) {
      return ['stretch', 'x-small'].includes(value)
    }
  }
})

const calculatedIconColour = computed(() => {
  const darkBgColours = ['dark-grey', 'black']
  return darkBgColours.includes(props.backgroundColour) ? 'white' : 'black'
})

</script>

<style lang="postcss">
.CarouselArrow__button {
  &--is-visible {
    @apply opacity-100 pointer-events-auto;
  }

  &--is-disabled {
    @apply opacity-40 pointer-events-auto;
  }
  
  &--rotated {
    @apply rotate-180;
  }
}
</style>
